import React, { useEffect, useMemo, useState } from 'react';
import NavigationButtons from '../NavigationButtons';
import { buildHiddenCustomerData, fetchLatestCustomerRequest, fetchRequestSetupCatalog } from '../../../services/comersRequestFlow';
import { formatCUIL } from '../../../utils/documentFormatter';

export const BANKS = [
  { code: '007', name: 'Banco Galicia' },
  { code: '011', name: 'Banco Nación' },
  { code: '014', name: 'Banco Provincia BS AS' },
  { code: '015', name: 'Banco ICBC' },
  { code: '016', name: 'Citi Bank' },
  { code: '017', name: 'Banco BBVA Frances' },
  { code: '020', name: 'Bancor' },
  { code: '027', name: 'Banco Supervielle' },
  { code: '029', name: 'Banco Ciudad' },
  { code: '034', name: 'Banco Patagonia' },
  { code: '044', name: 'Banco Hipotecario' },
  { code: '045', name: 'Banco San Juan' },
  { code: '060', name: 'Banco Tucuman' },
  { code: '065', name: 'Banco Rosario' },
  { code: '072', name: 'Banco Santander' },
  { code: '083', name: 'Banco Chubut' },
  { code: '086', name: 'Banco Santa Cruz' },
  { code: '093', name: 'Banco La Pampa' },
  { code: '094', name: 'Banco Corrientes' },
  { code: '097', name: 'Banco Neuquén' },
  { code: '150', name: 'Banco HSBC' },
  { code: '191', name: 'Banco Credicoop' },
  { code: '198', name: 'Valores SA' },
  { code: '247', name: 'Banco Roela' },
  { code: '254', name: 'Banco Mariva' },
  { code: '259', name: 'Banco Itaú' },
  { code: '262', name: 'Banco America' },
  { code: '268', name: 'Banco Tierra del Fuego' },
  { code: '277', name: 'Banco Saenz' },
  { code: '281', name: 'Banco Meridian' },
  { code: '285', name: 'Banco Macro' },
  { code: '299', name: 'Banco Comafi' },
  { code: '301', name: 'Banco Piano' },
  { code: '309', name: 'Banco de La Rioja' },
  { code: '310', name: 'Banco Del SOL' },
  { code: '311', name: 'Banco de Chaco' },
  { code: '315', name: 'Banco Formosa' },
  { code: '321', name: 'Banco Santiago del Estero' },
  { code: '322', name: 'Banco Bind' },
  { code: '330', name: 'Banco Santa Fe' },
  { code: '341', name: 'Banco VOII' },
  { code: '386', name: 'Banco Entre Rios' },
  { code: '389', name: 'Banco Columbia' }
];

const BANK_LOGOS = {
  '007': 'https://cdn.cirenio.com/payments/banks/icons/galicia.png',
  '011': 'https://cdn.cirenio.com/payments/banks/icons/nacion.png',
  '014': 'https://cdn.cirenio.com/payments/banks/icons/provincia.png',
  '017': 'https://cdn.cirenio.com/payments/banks/icons/bbva.png',
  '020': 'https://cdn.cirenio.com/payments/banks/icons/bancor.png',
  '027': 'https://cdn.cirenio.com/payments/banks/icons/supervielle.png',
  '029': 'https://cdn.cirenio.com/payments/banks/icons/ciudad.png',
  '034': 'https://cdn.cirenio.com/payments/banks/icons/patagonia.png',
  '045': 'https://cdn.cirenio.com/payments/banks/icons/sanjuan21.png',
  '072': 'https://cdn.cirenio.com/payments/banks/icons/santander.png',
  '083': 'https://cdn.cirenio.com/payments/banks/icons/chubut.png',
  '086': 'https://cdn.cirenio.com/payments/banks/icons/santacruz21.png',
  '093': 'https://cdn.cirenio.com/payments/banks/icons/lapampa.png',
  '094': 'https://cdn.cirenio.com/payments/banks/icons/corrientes.png',
  '097': 'https://cdn.cirenio.com/payments/banks/icons/neuquen.png',
  '150': 'https://cdn.cirenio.com/payments/banks/icons/hsbc.png',
  '191': 'https://cdn.cirenio.com/payments/banks/icons/credicoop.png',
  '259': 'https://cdn.cirenio.com/payments/banks/icons/itau.png',
  '268': 'https://cdn.cirenio.com/payments/banks/icons/tierradelfuego.png',
  '285': 'https://cdn.cirenio.com/payments/banks/icons/macro.png',
  '301': 'https://cdn.cirenio.com/payments/banks/icons/piano.png',
  '311': 'https://cdn.cirenio.com/payments/banks/icons/chaco.png',
  '322': 'https://cdn.cirenio.com/payments/banks/icons/bind.png',
  '330': 'https://cdn.cirenio.com/payments/banks/icons/santafe21.png',
  '386': 'https://cdn.cirenio.com/payments/banks/icons/bersa21.png'
};

export const PROVINCES = [
  { id: '1', name: 'Salta' },
  { id: '2', name: 'Buenos Aires' },
  { id: '3', name: 'Capital Federal' },
  { id: '4', name: 'San Luis' },
  { id: '5', name: 'Entre Ríos' },
  { id: '6', name: 'La Rioja' },
  { id: '7', name: 'Santiago del Estero' },
  { id: '8', name: 'Chaco' },
  { id: '9', name: 'San Juan' },
  { id: '10', name: 'Catamarca' },
  { id: '11', name: 'La Pampa' },
  { id: '12', name: 'Mendoza' },
  { id: '13', name: 'Misiones' },
  { id: '14', name: 'Formosa' },
  { id: '15', name: 'Neuquén' },
  { id: '16', name: 'Rio Negro' },
  { id: '17', name: 'Santa Fe' },
  { id: '18', name: 'Tucuman' },
  { id: '19', name: 'Chubut' },
  { id: '20', name: 'Tierra del Fuego' },
  { id: '21', name: 'Corrientes' },
  { id: '22', name: 'Córdoba' },
  { id: '23', name: 'Jujuy' },
  { id: '24', name: 'Santa Cruz' }
];

/**
 * UI fija de situación laboral. Los `key` de hojas seleccionables coinciden con los códigos del backend.
 * Nodos estructurales (ACTIVE, PUBLIC_EMPLOYEE, RETIRED) no son valores enviados al API.
 */
export const EMPLOYMENT_STRUCTURE = [
  {
    key: 'ACTIVE',
    label: 'Activos',
    selectable: false,
    children: [
      {
        key: 'PUBLIC_EMPLOYEE',
        label: 'Empleado Público',
        selectable: false,
        children: [
          { key: 'PUBLIC_FFAA', label: 'Empleado de FFAA', selectable: true, employer: 1 },
          { key: 'PUBLIC_NATIONAL', label: 'Empleado Nacional', selectable: true, employer: 1 },
          { key: 'PUBLIC_PROVINCIAL', label: 'Empleado Provincial', selectable: true, employer: 1 },
          { key: 'PUBLIC_MUNICIPAL', label: 'Empleado Municipal', selectable: true, employer: 1 }
        ]
      },
      {
        key: 'PRIVATE_EMPLOYEE',
        label: 'Empleado Privado',
        selectable: true,
        employer: 1
      }
    ]
  },
  {
    key: 'RETIRED',
    label: 'Jubilados, Pensionados o Retirados',
    selectable: false,
    children: [
      { key: 'ANSES_ORDINARY_PENSION', label: 'Jubilación o Pensión Ordinaria Anses', selectable: true, employer: 0 },
      { key: 'ANSES_GRACIABLE_PENSION', label: 'Pensión Graciable Anses', selectable: true, employer: 0 },
      { key: 'SPECIAL_FUNDS', label: 'Cajas Especiales', selectable: true, employer: 0 }
    ]
  }
];

const collectEmploymentLeafKeys = (nodes) => {
  const keys = new Set();
  const visit = (list) => {
    for (const node of list) {
      if (node.selectable) {
        keys.add(node.key);
      }
      if (node.children?.length) {
        visit(node.children);
      }
    }
  };
  visit(nodes);
  return keys;
};

export const EMPLOYMENT_LEAF_KEYS = collectEmploymentLeafKeys(EMPLOYMENT_STRUCTURE);

const collectEmploymentMetaByCode = (nodes) => {
  const map = new Map();
  const visit = (list) => {
    for (const node of list) {
      if (node.selectable) {
        map.set(node.key, {
          code: node.key,
          id: node.id,
          employer: typeof node.employer === 'number' ? node.employer : undefined
        });
      }
      if (node.children?.length) {
        visit(node.children);
      }
    }
  };
  visit(nodes);
  return map;
};

const buildEmploymentOptgroups = (structure) => {
  const map = new Map();

  const visit = (nodes, pathPrefix) => {
    for (const node of nodes) {
      if (node.selectable) {
        const groupLabel = pathPrefix.join(' — ');
        if (!map.has(groupLabel)) {
          map.set(groupLabel, []);
        }
        map.get(groupLabel).push({ key: node.key, label: node.label });
      }
      if (node.children?.length) {
        const childPath = node.selectable ? pathPrefix : [...pathPrefix, node.label];
        visit(node.children, childPath);
      }
    }
  };

  visit(structure, []);
  return Array.from(map.entries()).map(([label, options]) => ({ label, options }));
};

/**
 * Construye los grupos de opciones para el segundo select (detalle) a partir de un nodo padre.
 * Recorre todos los descendientes seleccionables y los agrupa por su path estructural (los
 * nodos intermedios no-seleccionables se vuelven `optgroup`).
 */
const buildChildEmploymentOptgroups = (parentNode) => {
  if (!parentNode || !Array.isArray(parentNode.children) || parentNode.children.length === 0) {
    return [];
  }

  const map = new Map();

  const visit = (nodes, pathPrefix) => {
    for (const node of nodes) {
      if (node.selectable) {
        const groupLabel = pathPrefix.join(' — ');
        if (!map.has(groupLabel)) {
          map.set(groupLabel, []);
        }
        map.get(groupLabel).push({ key: node.key, label: node.label });
      }
      if (node.children?.length) {
        const childPath = node.selectable ? pathPrefix : [...pathPrefix, node.label];
        visit(node.children, childPath);
      }
    }
  };

  visit(parentNode.children, []);
  return Array.from(map.entries()).map(([label, options]) => ({ label, options }));
};

/**
 * Devuelve un mapa key-de-hoja -> key-del-nodo-raíz para poder reconstruir la selección del
 * primer select cuando solo conocemos el código de la hoja (por ejemplo al restaurar una
 * solicitud previa).
 */
const buildLeafToRootMap = (structure) => {
  const map = new Map();
  const visit = (nodes, rootKey) => {
    for (const node of nodes) {
      const currentRoot = rootKey || node.key;
      if (node.selectable) {
        map.set(node.key, currentRoot);
      }
      if (node.children?.length) {
        visit(node.children, currentRoot);
      }
    }
  };
  visit(structure, '');
  return map;
};

const normalizeEmploymentStructure = (statuses = []) => {
  if (!Array.isArray(statuses)) {
    return EMPLOYMENT_STRUCTURE;
  }

  const normalizeNode = (status) => {
    const children = Array.isArray(status.children)
      ? status.children.map(normalizeNode).filter(Boolean)
      : [];
    const key = status.code || status.key || status.id;

    const label = status.name || status.label;

    if (!key || !label) {
      return null;
    }

    return {
      key: String(key),
      id: status.id != null ? Number(status.id) : undefined,
      label: String(label),
      employer: status.employer === 0 || status.employer === 1 || status.employer === '0' || status.employer === '1'
        ? Number(status.employer)
        : undefined,
      selectable: typeof status.selectable === 'boolean'
        ? status.selectable
        : children.length === 0,
      children
    };
  };

  return statuses.map(normalizeNode).filter(Boolean);
};

const formatAmount = (value) => {
  if (value === '' || value === null || value === undefined) {
    return '';
  }

  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return '';
  }

  return numeric.toLocaleString('es-AR');
};

const normalizeSearchValue = (value) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

const sanitizeBanks = (banks = []) =>
  banks
    .filter((bank) => bank && bank.code)
    .map((bank) => ({
      id: bank.id ? String(bank.id) : String(bank.code),
      code: String(bank.code),
      name: String(bank.name || '').trim(),
      logo: String(bank.logo || BANK_LOGOS[String(bank.code)] || '').trim()
    }));

const sanitizeProvinces = (provinces = []) =>
  provinces
    .filter((province) => province && province.id)
    .map((province) => ({
      id: String(province.id),
      name: String(province.name || '').trim()
    }));

const normalizeProductScopes = (scopes = []) => {
  if (!Array.isArray(scopes)) {
    return [];
  }

  return scopes
    .map((scope) => ({
      productId: scope.product_id ? String(scope.product_id) : '',
      employmentCodes: Array.isArray(scope.employment_codes)
        ? scope.employment_codes.map((code) => String(code)).filter(Boolean)
        : [],
      bankCodes: Array.isArray(scope.bank_codes)
        ? scope.bank_codes.map((code) => String(code)).filter(Boolean)
        : [],
      provinceIds: Array.isArray(scope.province_ids)
        ? scope.province_ids.map((provinceId) => String(provinceId)).filter(Boolean)
        : []
    }))
    .filter((scope) =>
      scope.employmentCodes.length > 0 &&
      scope.bankCodes.length > 0 &&
      scope.provinceIds.length > 0
    );
};

const SearchableSelect = ({
  label,
  name,
  value,
  options,
  onChange,
  disabled = false,
  placeholder = 'Buscar...',
  emptyMessage = 'Sin resultados',
  getOptionLabel = (option) => option.name,
  getOptionValue = (option) => option.id,
  renderOption = null,
  renderLeading = null
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);

  const selectedOption = useMemo(
    () => options.find((option) => String(getOptionValue(option)) === String(value)) || null,
    [getOptionValue, options, value]
  );

  useEffect(() => {
    setSearchTerm(selectedOption ? getOptionLabel(selectedOption) : '');
  }, [getOptionLabel, selectedOption]);

  const filteredOptions = useMemo(() => {
    const normalizedTerm = normalizeSearchValue(searchTerm);
    const sortedOptions = [...options].sort((left, right) =>
      normalizeSearchValue(getOptionLabel(left)).localeCompare(normalizeSearchValue(getOptionLabel(right)))
    );

    if (!normalizedTerm) {
      return sortedOptions;
    }

    return sortedOptions.filter((option) =>
      normalizeSearchValue(getOptionLabel(option)).includes(normalizedTerm)
    );
  }, [getOptionLabel, options, searchTerm]);

  const emitValue = (nextValue) => {
    if (String(nextValue) === String(value || '')) {
      return;
    }

    onChange({
      target: {
        name,
        value: nextValue
      }
    });
  };

  const handleInputChange = (event) => {
    const nextValue = event.target.value;
    setSearchTerm(nextValue);
    setShowDropdown(true);

    if (!nextValue.trim()) {
      emitValue('');
      return;
    }

    const exactMatch = options.find(
      (option) => normalizeSearchValue(getOptionLabel(option)) === normalizeSearchValue(nextValue)
    );

    if (exactMatch) {
      emitValue(String(getOptionValue(exactMatch)));
      return;
    }

    if (selectedOption) {
      emitValue('');
    }
  };

  const handleSelect = (option) => {
    setSearchTerm(getOptionLabel(option));
    setShowDropdown(false);
    emitValue(String(getOptionValue(option)));
  };

  const handleBlur = () => {
    window.setTimeout(() => {
      setShowDropdown(false);
      if (selectedOption) {
        setSearchTerm(getOptionLabel(selectedOption));
      }
    }, 150);
  };

  return (
    <div className="rg-request-searchable-select">
      <label className="form-label">{label}</label>
      <div className="position-relative">
        {selectedOption && renderLeading ? (
          <div className="rg-request-searchable-select__leading">
            {renderLeading(selectedOption)}
          </div>
        ) : null}

        <input
          type="text"
          className={`form-control rg-request-searchable-select__input ${selectedOption && renderLeading ? 'rg-request-searchable-select__input--with-leading' : ''}`}
          value={searchTerm}
          onChange={handleInputChange}
          onFocus={() => setShowDropdown(true)}
          onBlur={handleBlur}
          placeholder={placeholder}
          autoComplete="off"
          disabled={disabled}
        />

        {showDropdown && !disabled ? (
          <div className="dropdown-menu show w-100 rg-request-searchable-select__menu">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <button
                  key={getOptionValue(option)}
                  type="button"
                  className={`dropdown-item rg-request-searchable-select__option ${String(getOptionValue(option)) === String(value) ? 'active' : ''}`}
                  onMouseDown={(event) => event.preventDefault()}
                  onClick={() => handleSelect(option)}
                >
                  {renderOption ? renderOption(option) : getOptionLabel(option)}
                </button>
              ))
            ) : (
              <div className="dropdown-item-text text-muted text-center py-3">
                {emptyMessage}
              </div>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

const RequestSetupStep = ({
  onNext,
  formData = {},
  clientData = {},
  productRequirements = null,
  isLoading = false
}) => {
  const demoMode = process.env.REACT_APP_REQUEST_FLOW_DEMO === 'true';
  const [catalog, setCatalog] = useState({
    banks: demoMode ? sanitizeBanks(BANKS) : [],
    provinces: demoMode ? PROVINCES : [],
    defaultProvince: null,
    employmentStructure: demoMode ? EMPLOYMENT_STRUCTURE : [],
    productScopes: [],
    hasProductScopesCatalog: false,
    requirementHints: null
  });
  const [isLoadingCatalog, setIsLoadingCatalog] = useState(!demoMode);
  const [catalogError, setCatalogError] = useState('');
  const [localData, setLocalData] = useState({
    bank: formData.bank || '',
    province: formData.province || '',
    commitments: formData.commitments || '',
    employmentParent: formData.employmentParent || '',
    employmentStatus: formData.employmentStatus || '',
    salary: formData.salary || '',
    companyIdentification: formData.companyIdentification || '',
    joinDate: formData.joinDate || ''
  });

  useEffect(() => {
    if (demoMode || !clientData?.id) {
      return;
    }

    let ignore = false;

    const loadData = async () => {
      setIsLoadingCatalog(true);

      try {
        const [catalogData, latestRequest] = await Promise.all([
          fetchRequestSetupCatalog(),
          fetchLatestCustomerRequest(clientData.id)
        ]);

        if (ignore) {
          return;
        }

        setCatalog({
          banks: sanitizeBanks(catalogData.banks || []),
          provinces: sanitizeProvinces(catalogData.provinces || []),
          defaultProvince: catalogData.default_province ? String(catalogData.default_province.id) : '',
          employmentStructure: normalizeEmploymentStructure(catalogData.employment_statuses),
          productScopes: normalizeProductScopes(catalogData.product_scopes),
          hasProductScopesCatalog: Array.isArray(catalogData.product_scopes),
          requirementHints: catalogData.requirement_hints || null
        });
        setCatalogError('');

        const latestSetup = latestRequest?.request_setup || {};
        const latestEmployment = latestSetup.employment_status;
        const savedCode = latestEmployment?.code || '';

        setLocalData((prev) => ({
          ...prev,
          bank: prev.bank || latestSetup.bank?.code || '',
          province: prev.province || String(latestSetup.province_id || catalogData.default_province?.id || ''),
          commitments: prev.commitments || String(latestSetup.commitments || ''),
          salary: prev.salary || String(latestSetup.salary || ''),
          employmentStatus: prev.employmentStatus || savedCode || '',
          companyIdentification: prev.companyIdentification
            || String(latestSetup.company_identification || '').replace(/\D/g, ''),
          joinDate: prev.joinDate || latestSetup.join_date || ''
        }));
      } catch (error) {
        console.error('Error loading request setup catalog:', error);
        if (!ignore) {
          setCatalogError('No pudimos cargar el catálogo de productos. Reintentá en unos segundos.');
        }
      } finally {
        if (!ignore) {
          setIsLoadingCatalog(false);
        }
      }
    };

    loadData();

    return () => {
      ignore = true;
    };
  }, [clientData?.id, demoMode]);

  useEffect(() => {
    if (!demoMode) {
      return;
    }

    setLocalData((prev) => ({
      ...prev,
      province: prev.province || '2'
    }));
  }, [demoMode]);

  const employmentLeafKeys = useMemo(
    () => collectEmploymentLeafKeys(catalog.employmentStructure),
    [catalog.employmentStructure]
  );

  const employmentMetaByCode = useMemo(
    () => collectEmploymentMetaByCode(catalog.employmentStructure),
    [catalog.employmentStructure]
  );

  const selectedEmploymentMeta = employmentMetaByCode.get(localData.employmentStatus);
  const requiresEmployerCuit = selectedEmploymentMeta?.employer === 1;

  const employmentOptgroups = useMemo(
    () => buildEmploymentOptgroups(catalog.employmentStructure),
    [catalog.employmentStructure]
  );

  const leafToRootMap = useMemo(
    () => buildLeafToRootMap(catalog.employmentStructure),
    [catalog.employmentStructure]
  );

  const employmentParentOptions = useMemo(
    () => catalog.employmentStructure.map((node) => ({ key: node.key, label: node.label })),
    [catalog.employmentStructure]
  );

  const employmentChildOptgroups = useMemo(() => {
    const parent = catalog.employmentStructure.find((node) => node.key === localData.employmentParent);
    return buildChildEmploymentOptgroups(parent);
  }, [catalog.employmentStructure, localData.employmentParent]);

  // Cuando viene una `employmentStatus` (hoja) preseleccionada pero todavía no resolvimos el
  // padre (por ejemplo al restaurar una solicitud anterior), lo derivamos desde la estructura.
  useEffect(() => {
    if (!localData.employmentStatus || localData.employmentParent) {
      return;
    }
    const rootKey = leafToRootMap.get(localData.employmentStatus);
    if (rootKey) {
      setLocalData((prev) => ({ ...prev, employmentParent: rootKey }));
    }
  }, [leafToRootMap, localData.employmentParent, localData.employmentStatus]);

  const usesScopedCatalog = catalog.hasProductScopesCatalog;

  const retiredEmploymentCodes = useMemo(
    () => new Set(catalog.requirementHints?.retired_employment_codes || []),
    [catalog.requirementHints]
  );

  const isRetiredEmployment = retiredEmploymentCodes.has(localData.employmentStatus);

  const incomeLabel = productRequirements?.labels?.income_label
    || (isRetiredEmployment
      ? catalog.requirementHints?.retired_labels?.income_label
      : catalog.requirementHints?.default_labels?.income_label)
    || 'Salario neto';

  const bankLabel = productRequirements?.labels?.bank_label
    || (isRetiredEmployment
      ? catalog.requirementHints?.retired_labels?.bank_label
      : catalog.requirementHints?.default_labels?.bank_label)
    || 'Banco donde cobras tu sueldo';

  const filteredBanks = useMemo(() => {
    if (!usesScopedCatalog) {
      return catalog.banks;
    }

    if (!localData.employmentStatus) {
      return [];
    }

    const allowedBankCodes = new Set(
      catalog.productScopes
        .filter((scope) => scope.employmentCodes.includes(localData.employmentStatus))
        .flatMap((scope) => scope.bankCodes)
    );

    return catalog.banks.filter((bank) => allowedBankCodes.has(String(bank.code)));
  }, [catalog.banks, catalog.productScopes, localData.employmentStatus, usesScopedCatalog]);

  const filteredProvinces = useMemo(() => {
    if (!usesScopedCatalog) {
      return catalog.provinces;
    }

    if (!localData.employmentStatus || !localData.bank) {
      return [];
    }

    const allowedProvinceIds = new Set(
      catalog.productScopes
        .filter((scope) =>
          scope.employmentCodes.includes(localData.employmentStatus) &&
          scope.bankCodes.includes(localData.bank)
        )
        .flatMap((scope) => scope.provinceIds)
    );

    return catalog.provinces.filter((province) => allowedProvinceIds.has(String(province.id)));
  }, [catalog.productScopes, catalog.provinces, localData.bank, localData.employmentStatus, usesScopedCatalog]);

  const hasValidScopedCombination = useMemo(() => {
    if (!usesScopedCatalog) {
      return true;
    }

    if (!localData.employmentStatus || !localData.bank || !localData.province) {
      return false;
    }

    return catalog.productScopes.some((scope) =>
      scope.employmentCodes.includes(localData.employmentStatus) &&
      scope.bankCodes.includes(localData.bank) &&
      scope.provinceIds.includes(String(localData.province))
    );
  }, [catalog.productScopes, localData.bank, localData.employmentStatus, localData.province, usesScopedCatalog]);

  useEffect(() => {
    if (!usesScopedCatalog) {
      return;
    }

    setLocalData((prev) => {
      const next = { ...prev };
      const selectedEmploymentIsValid = !next.employmentStatus || employmentLeafKeys.has(next.employmentStatus);
      const selectedBankIsValid = !next.bank || filteredBanks.some((bank) => String(bank.code) === String(next.bank));
      const selectedProvinceIsValid = !next.province || filteredProvinces.some((province) => String(province.id) === String(next.province));

      if (!selectedEmploymentIsValid) {
        next.employmentParent = '';
        next.employmentStatus = '';
        next.bank = '';
        next.province = '';
      } else if (!selectedBankIsValid) {
        next.bank = '';
        next.province = '';
      } else if (!selectedProvinceIsValid) {
        next.province = '';
      }

      return next.employmentParent === prev.employmentParent &&
        next.employmentStatus === prev.employmentStatus &&
        next.bank === prev.bank &&
        next.province === prev.province
        ? prev
        : next;
    });
  }, [employmentLeafKeys, filteredBanks, filteredProvinces, usesScopedCatalog]);

  const isValid = useMemo(() => {
    const salaryNumber = Number(localData.salary);
    const commitmentsNumber = Number(localData.commitments || 0);
    const employerCuitValid = !requiresEmployerCuit || (
      typeof localData.companyIdentification === 'string' &&
      localData.companyIdentification.length === 11
    );
    const joinDateValid = !requiresEmployerCuit || Boolean(localData.joinDate);
    return (
      Boolean(localData.bank) &&
      Boolean(localData.province) &&
      employmentLeafKeys.has(localData.employmentStatus) &&
      hasValidScopedCombination &&
      Number.isFinite(salaryNumber) &&
      salaryNumber > 0 &&
      Number.isFinite(commitmentsNumber) &&
      commitmentsNumber >= 0 &&
      employerCuitValid &&
      joinDateValid
    );
  }, [employmentLeafKeys, hasValidScopedCombination, localData, requiresEmployerCuit]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === 'salary' || name === 'commitments') {
      const normalized = value.replace(/[^\d]/g, '');
      setLocalData((prev) => ({ ...prev, [name]: normalized }));
      return;
    }

    if (name === 'companyIdentification') {
      const normalized = value.replace(/\D/g, '').slice(0, 11);
      setLocalData((prev) => ({ ...prev, companyIdentification: normalized }));
      return;
    }

    if (name === 'employmentParent') {
      setLocalData((prev) => ({
        ...prev,
        employmentParent: value,
        employmentStatus: '',
        bank: '',
        province: '',
        companyIdentification: '',
        joinDate: ''
      }));
      return;
    }

    if (name === 'employmentStatus') {
      setLocalData((prev) => {
        const meta = employmentMetaByCode.get(value);
        const next = {
          ...prev,
          employmentStatus: value,
          bank: '',
          province: ''
        };
        if (meta?.employer !== 1) {
          next.companyIdentification = '';
          next.joinDate = '';
        }
        return next;
      });
      return;
    }

    if (name === 'bank') {
      setLocalData((prev) => ({
        ...prev,
        bank: value,
        province: ''
      }));
      return;
    }

    setLocalData((prev) => ({ ...prev, [name]: value }));
  };

  const handleNext = () => {
    const hiddenCustomerData = buildHiddenCustomerData(clientData);

    onNext({
      hiddenCustomerData,
      requestSetup: {
        bank: localData.bank,
        province: localData.province,
        commitments: Number(localData.commitments || 0),
        salary: Number(localData.salary || 0),
        employmentStatus: localData.employmentStatus,
        ...(requiresEmployerCuit && localData.companyIdentification
          ? { companyIdentification: localData.companyIdentification }
          : {}),
        ...(requiresEmployerCuit && localData.joinDate
          ? { joinDate: localData.joinDate }
          : {})
      }
    });
  };

  const noAvailableProducts = !isLoadingCatalog &&
    !demoMode &&
    !catalogError &&
    (
      (catalog.hasProductScopesCatalog && catalog.productScopes.length === 0) ||
      (!catalog.hasProductScopesCatalog &&
        catalog.banks.length === 0 &&
        catalog.provinces.length === 0 &&
        employmentOptgroups.length === 0)
    );

  return (
    <div className="container rg-request-data-step">
      {catalogError ? (
        <div className="alert alert-warning" role="alert">
          {catalogError}
        </div>
      ) : null}

      {noAvailableProducts ? (
        <div className="alert alert-warning" role="alert">
          No hay productos disponibles para este comercio/canal.
        </div>
      ) : null}

      <div className="row g-3">
        <div className="col-12 col-md-6">
          <label className="form-label">Situación laboral</label>
          <select
            className="form-select"
            name="employmentParent"
            value={localData.employmentParent}
            onChange={handleChange}
            disabled={isLoadingCatalog || Boolean(catalogError) || noAvailableProducts}
          >
            <option value="">Seleccionar grupo</option>
            {employmentParentOptions.map((opt) => (
              <option key={opt.key} value={opt.key}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12 col-md-6">
          <label className="form-label">Detalle situación laboral</label>
          <select
            className="form-select"
            name="employmentStatus"
            value={employmentLeafKeys.has(localData.employmentStatus) ? localData.employmentStatus : ''}
            onChange={handleChange}
            disabled={
              isLoadingCatalog ||
              Boolean(catalogError) ||
              noAvailableProducts ||
              !localData.employmentParent ||
              employmentChildOptgroups.length === 0
            }
          >
            <option value="">
              {localData.employmentParent
                ? 'Seleccionar detalle'
                : 'Primero seleccioná situación laboral'}
            </option>
            {employmentChildOptgroups.map((group) =>
              group.label ? (
                <optgroup key={group.label} label={group.label}>
                  {group.options.map((opt) => (
                    <option key={opt.key} value={opt.key}>
                      {opt.label}
                    </option>
                  ))}
                </optgroup>
              ) : (
                group.options.map((opt) => (
                  <option key={opt.key} value={opt.key}>
                    {opt.label}
                  </option>
                ))
              )
            )}
          </select>
        </div>

        <div className="col-12 col-md-6">
          <SearchableSelect
            label={bankLabel}
            name="bank"
            value={localData.bank}
            options={filteredBanks}
            onChange={handleChange}
            disabled={isLoadingCatalog || Boolean(catalogError) || noAvailableProducts || (usesScopedCatalog && !localData.employmentStatus)}
            placeholder={usesScopedCatalog && !localData.employmentStatus ? 'Primero seleccioná situación laboral' : 'Buscar banco...'}
            emptyMessage={usesScopedCatalog ? 'No hay bancos disponibles para esta situación laboral' : 'No se encontraron bancos'}
            getOptionLabel={(bank) => bank.name}
            getOptionValue={(bank) => bank.code}
            renderLeading={(bank) =>
              bank.logo ? (
                <span className="rg-request-searchable-select__bank-logo-wrap">
                  <img
                    src={bank.logo}
                    alt={bank.name}
                    className="rg-request-searchable-select__bank-logo"
                  />
                </span>
              ) : (
                <i className="bi bi-bank text-muted" aria-hidden />
              )
            }
            renderOption={(bank) => (
              <div className="d-flex align-items-center gap-2">
                <span className="rg-request-searchable-select__bank-logo-wrap">
                  {bank.logo ? (
                    <img
                      src={bank.logo}
                      alt={bank.name}
                      className="rg-request-searchable-select__bank-logo"
                    />
                  ) : (
                    <i className="bi bi-bank text-muted" aria-hidden />
                  )}
                </span>
                <span>{bank.name}</span>
              </div>
            )}
          />
        </div>

        {requiresEmployerCuit ? (
          <div className="col-12 col-md-6">
            <label className="form-label" htmlFor="companyIdentification">
              CUIT del empleador
            </label>
            <input
              id="companyIdentification"
              type="text"
              className="form-control"
              name="companyIdentification"
              value={formatCUIL(localData.companyIdentification)}
              onChange={handleChange}
              placeholder="XX-XXXXXXXX-X"
              inputMode="numeric"
              autoComplete="off"
            />
          </div>
        ) : null}

        {requiresEmployerCuit ? (
          <div className="col-12 col-md-6">
            <label className="form-label" htmlFor="joinDate">
              Fecha de ingreso
            </label>
            <input
              id="joinDate"
              type="date"
              className="form-control"
              name="joinDate"
              value={localData.joinDate || ''}
              onChange={handleChange}
              max={new Date().toISOString().split('T')[0]}
              autoComplete="off"
            />
          </div>
        ) : null}

        <div className="col-12 col-md-6">
          <label className="form-label">{incomeLabel}</label>
          <div className="input-group">
            <span className="input-group-text">$</span>
            <input
              type="text"
              className="form-control"
              name="salary"
              value={formatAmount(localData.salary)}
              onChange={handleChange}
              placeholder="0"
              inputMode="numeric"
            />
          </div>
        </div>

        <div className="col-12 col-md-6">
          <label className="form-label">Compromisos</label>
          <div className="input-group">
            <span className="input-group-text">$</span>
            <input
              type="text"
              className="form-control"
              name="commitments"
              value={formatAmount(localData.commitments)}
              onChange={handleChange}
              placeholder="0"
              inputMode="numeric"
            />
          </div>
        </div>

        <div className="col-12 col-md-6">
          <SearchableSelect
            label="Provincia"
            name="province"
            value={localData.province}
            options={filteredProvinces}
            onChange={handleChange}
            disabled={isLoadingCatalog || Boolean(catalogError) || noAvailableProducts || (usesScopedCatalog && (!localData.employmentStatus || !localData.bank))}
            placeholder={usesScopedCatalog && !localData.bank ? 'Primero seleccioná banco' : 'Buscar provincia...'}
            emptyMessage={usesScopedCatalog ? 'No hay provincias disponibles para esta combinación' : 'No se encontraron provincias'}
            getOptionLabel={(province) => province.name}
            getOptionValue={(province) => province.id}
            renderOption={(province) => (
              <div className="d-flex align-items-center gap-2">
                <i className="bi bi-geo-alt text-muted" aria-hidden />
                <span>{province.name}</span>
              </div>
            )}
          />
        </div>
      </div>

      <NavigationButtons onNext={handleNext} disableNext={!isValid} isLoading={isLoading} />
    </div>
  );
};

export default RequestSetupStep;
